import { useFm } from '@web3/base-hooks';
import styles from './FeatureCard.module.scss';
import { Exchange } from '@/types/bbsol';
import { isApp } from '@/utils/common';
import { bybitHecate } from '@web3/base-utils';
import ArrowRight from '@/assets/images/bybitsol/arrow-right.svg';
import { Event } from '@/config/track-config';
import { scTrack } from '@web3/base-tracking';
type FeatureCardProps = {
  data: Exchange;
};

export const FeatureCard = ({ data }: FeatureCardProps) => {
  const fm = useFm();

  const handleClick = () => {
    scTrack(Event.Web3UserClick, {
      page_name: 'StakingWeb_BBSOLhomepage',
      button_name: `Cefi_Viewmore_${data?.title}`,
    });

    if (isApp()) {
      bybitHecate('Router', 'push', {
        path: data.appUrl,
      });
    } else {
      const link = `https://app.bybit.com/inapp?by_dp=${data?.appUrl}&by_web_link=${encodeURIComponent(data?.url)}&force_redirect=true`;
      window.top?.open(link);
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>{data.title}</h3>
        <img src={data.logoUrl} alt="" className={styles.icon} />
      </div>
      <p className={styles.subtitle}>{data.description}</p>
      <div className={styles.link} onClick={handleClick}>
        {fm('viewMore')}
        <ArrowRight />
      </div>
    </div>
  );
};
